import { FEATURES, type ShowroomSectionKey } from '@makemydeal/dr-sales-checkin-types';

export const SALES_CHECKIN_DEV2_DOMAIN = 'dev2.sales.app.coxautoinc.com';
export const STATIC_IMAGES_BASE_PATH = '/static/img';
export const DEFAULT_PROTOCOL = 'https';
export const SALES_VIEW_HOST_NAME = 'showroom.app.coxautoinc.com';

export const DEV_PARAMS = ['bffEnv', 'uiEnv', 'enableToggles', 'disableToggles'];

export const SALES_CHECKIN_MODE = 'sales-checkin-mode';

export const NO_DEALERSHIP_ASSOCIATED_MESSAGE = 'No dealership is associated with this user. Please contact support.';

export const DealerKeyName = 'MMD';

// Continuous-scroll page (F304636). Tuning for the scroll engine and the active-section maths.
export const ACTIVATION_LINE_RATIO = 0.3;
export const BOTTOM_EPSILON_PX = 2;
export const SECTION_SCROLL_MARGIN_PX = 16;
export const SETTLE_IDLE_MS = 150;
export const SETTLE_MAX_MS = 1500;
export const LAZY_MOUNT_VISIBLE_RATIO = 0.3;
export const LAZY_MOUNT_THRESHOLDS = [0, LAZY_MOUNT_VISIBLE_RATIO, 1];

export const SECTION_MIN_HEIGHT_PX: Record<ShowroomSectionKey, number> = {
    [FEATURES.VEHICLE_DETAILS]: 900,
    [FEATURES.TRADE_IN]: 240,
    [FEATURES.CUSTOMER_DETAILS]: 240,
    [FEATURES.DEAL_SUMMARY]: 1200
};

/** Keys that scroll the page themselves, so pressing one means the user is taking the scroll over. */
export const SCROLLING_KEYS = ['PageUp', 'PageDown', 'Home', 'End', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', ' '];

/** Anything here means the user has started scrolling themselves, and we stop competing with them. */
export const USER_INTENT_EVENTS = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
